import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore } from 'angularfire2/firestore';

import { switchMap, map, tap, catchError } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';

import * as paymentActions from '../../store/actions/payment.action';
import { Store } from '@ngrx/store';

@Injectable()
export class PaymentService {
  userId: string;
  hasPaid: boolean;
  constructor(
    private db: AngularFirestore,
    private afAuth: AngularFireAuth,
    private store: Store<any>,
    private http: HttpClient
  ) {
    this.afAuth.authState.subscribe(auth => {
      if (auth) {
        this.userId = auth.uid;
      }
    });
  }

  processAccommodationPayment(paymentData: any, amount) {
    this.afAuth.authState
      .pipe(
        map(auth => {
          if (auth) {
            const payment = { paymentData, amount };
            return this.db
              .collection(`/users/${auth.uid}/accommodationPayments`)
              .add(payment);
          }
        })
      )
      .subscribe();
  }

  processConferencePayment(paymentData: any, amount) {
    this.afAuth.authState
      .pipe(
        map(auth => {
          if (auth) {
            const payment = { paymentData, amount };
            return this.db
              .collection(`/users/${auth.uid}/conferencePayments`)
              .add(payment);
          }
        })
      )
      .subscribe();
  }

  checkAccommodationPayment() {
    this.afAuth.authState
      .pipe(
        map(auth => {
          if (auth) {
            return this.db
              .collection(`/users`)
              .doc(`${auth.uid}`)
              .ref.collection('accommodationPayments')
              .get()
              .then(docs => {
                this.store.dispatch(
                  new paymentActions.CheckAccommodationPayment(!docs.empty)
                );
              });
          }
        })
      )
      .subscribe();
  }

  checkConferencePayment() {
    this.afAuth.authState
      .pipe(
        map(auth => {
          if (auth) {
            return this.db
              .collection(`/users`)
              .doc(`${auth.uid}`)
              .ref.collection('conferencePayments')
              .get()
              .then(docs => {
                this.store.dispatch(
                  new paymentActions.CheckConferencePayment(!docs.empty)
                );
              });
          }
        })
      )
      .subscribe();
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/services/payment.service.ts